import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError } from "@nju/result";
import { IPaymentsTranslationsResult } from "./types";
import { serverResponse } from "./validators";

export async function fetchTranslations(): Promise<IPaymentsTranslationsResult> {
  const result = await client(
    `${
      process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST || "unknown"
    }/static/locize/cf86343e-4825-48a1-9b5c-ba3468db7472/latest/pl/productOffering`,
    {
      method: "get",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
